/*
Usage: tracking.js
---
import tracking from './lib/tracking'

// 問い合わせ導線を GA4 と Clarity にイベント送信する
// gtag は header.php でログアウト時のみ読み込まれるため、ログイン中は何もしない
tracking();
*/

// Contact Form 7 の送信結果。ディスカッション設定の「コメント内で許可されないキーワード」で弾かれた送信は wpcf7spam になる
const cf7Events = {
  wpcf7mailsent: "contact_form_sent",
  wpcf7spam: "contact_form_spam",
  wpcf7invalid: "contact_form_invalid",
  wpcf7mailfailed: "contact_form_failed",
};

// LINE・地図・Instagram・電話リンクのクリック
const linkRules = [
  [/^https:\/\/lin\.ee\//, "line_click"],
  [/^https:\/\/(maps\.app\.goo\.gl|www\.google\.[a-z.]+\/maps)\//, "map_click"],
  [/^https:\/\/www\.instagram\.com\//, "instagram_click"],
  [/^tel:/, "tel_click"],
];

const track = (name, params = {}) => {
  window.gtag("event", name, params);
  if (typeof window.clarity === "function") window.clarity("event", name);
};

const tracking = () => {
  if (typeof window.gtag !== "function") return;

  Object.entries(cf7Events).forEach(([type, name]) => {
    document.addEventListener(type, (e) => {
      const detail = e.detail || {};
      const inquiryType = (detail.inputs || []).find(
        (input) => input.name === "inquiry-type",
      );
      track(name, {
        form_id: String(detail.contactFormId || ""),
        inquiry_type: inquiryType ? inquiryType.value : "",
      });
    });
  });

  document.addEventListener("click", (e) => {
    const link = e.target.closest?.("a[href]");
    if (!link) return;
    const rule = linkRules.find(([pattern]) => pattern.test(link.href));
    if (!rule) return;
    // link_area はクリックされたセクション（クラス名の先頭）
    const area = link.closest("header, footer, section");
    track(rule[1], {
      link_url: link.href,
      link_area: area
        ? area.className.split(" ")[0] || area.tagName.toLowerCase()
        : "",
    });
  });
};

export default tracking;
